import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

export const AddAttendanceAPI = async (query, payload) => {
  try {
    const response = await axios.post(
      `${URL_API}/attendance${query}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const EditAttendanceAPI = async (id, payload) => {
  try {
    const response = await axios.put(`${URL_API}/attendance/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
export const DeleteAttendanceAPI = async (id) => {
  try {
    const response = await axios.delete(`${URL_API}/attendance/${id}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const GetAttendanceAPI = async ({
  companyId,
  requestDate,
  periodicId,
}) => {
  try {
    const params = new URLSearchParams(url.search);
    if (companyId) {
      params.append("company_id", companyId);
    }

    if (requestDate) {
      params.append("request_date", requestDate);
    }

    if (periodicId !== null) {
      params.append("periodic_id", periodicId);
    }
    const response = await axios.get(
      `${URL_API}/attendance?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
// export const EditAnnouncementAPI = async (id, payload) => {
//   try {
//     const response = await axios.put(`${URL_API}/announcement/${id}`, payload, {
//       headers: {
//         Authorization: `Bearer ${tokenDecrypted()}`,
//       },
//     });
//     return response;
//   } catch (error) {
//     return error.response;
//   }
// };
// export const GetAnnouncementAPI = async (query) => {
//   try {
//     const response = await axios.get(`${URL_API}/announcement${query}`, {
//       headers: {
//         Authorization: `Bearer ${tokenDecrypted()}`,
//       },
//     });
//     return response;
//   } catch (error) {
//     return error.response;
//   }
// };
// export const DeleteAnnouncementAPI = async (id) => {
//   try {
//     const response = await axios.delete(`${URL_API}/announcement/${id}`, {
//       headers: {
//         Authorization: `Bearer ${tokenDecrypted()}`,
//       },
//     });
//     return response;
//   } catch (error) {
//     return error.response;
//   }
// };
